import Icon from '../components/Icon.vue'

Icon.register({
  'list-ul': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M96 96c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48 48 21.5 48 48zM48 208c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM48 368c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM144 132c-8.8 0-16-7.2-16-16v-40c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v40c0 8.8-7.2 16-16 16h-352zM144 292c-8.8 0-16-7.2-16-16v-40c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v40c0 8.8-7.2 16-16 16h-352zM144 452c-8.8 0-16-7.2-16-16v-40c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v40c0 8.8-7.2 16-16 16h-352z'
      }
    ]
  }
})
